export var GdaDataType;
(function (GdaDataType) {
    /**64-bit signed integer. This is the only eligible type for the 'inc' API call*/
    GdaDataType["LONG"] = "LONG";
    /**Character String*/
    GdaDataType["STRING"] = "STRING";
    /**Boolean value : true or false*/
    GdaDataType["BOOLEAN"] = "BOOLEAN";
    /**Floating point number*/
    GdaDataType["DOUBLE"] = "DOUBLE";
    /**Complex object*/
    GdaDataType["OBJECT"] = "OBJECT";
})(GdaDataType || (GdaDataType = {}));
//# sourceMappingURL=GdaTypes.js.map